import { useEffect, useState } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

export default function DpcOrphans(){
    
    const columns = [
        {
            field: 'createdAt',
            headerName: 'Date',
            type: 'date',
            width: 90,
            valueGetter: i => new Date(i.row.createdAt.replace(' ','T')),
            renderCell: i => i.value.toLocaleString()
        },
        {
            field: 'name',
            headerName: 'Nom',
            width: 300,
            valueGetter: i => i.row.registrant?.name
        },
        {
            field: 'rpps',
            headerName: 'RPPS',
            width: 130,
            valueGetter: i => i.row.registrant?.rpps
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 200,
            valueGetter: i => i.row.registrant?.email
        },
        {
            field: 'action',
            headerName: 'Formation',
            width: 300,
            valueGetter: i => i.row.session?.action?.name
        },
        {
            field: 'session',
            headerName: 'Session',
            width: 240,
            valueGetter: i => i.row.session?.title
        },
        {
            field: 'contribution',
            headerName: 'Participation',
            type: 'number',
            width: 100,
            valueGetter: i => i.row.contribution,
            renderCell: i => i.value.toLocaleString() + '€'
        },
        {
            field: 'canceled',
            headerName: 'Annuler',
            width: 120,
            align: 'center',
            headerAlign: 'center',
            valueGetter: i => i.row.canceled,
            renderCell: i => (
                <IconButton
                    onClick={() => handleSwitch(i.row)} 
                    color="error"
                    size="small"
                >
                    <Close />
                </IconButton>
            )
        },
    ];

    const [items, setItems] = useState(null)

    useEffect(() => {

        API.get('/dpc/orphans')
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }, [])


    const handleSwitch = reg => {
        const ok = window.confirm("Êtes-vous sûr de vouloir annuler cette inscription ?");
        if (!ok) return;

        const oldItems = [...items];
       
        const newItems = [...items].filter(i => i.id !== reg.id);
        setItems(newItems);

        API.put(`/dpc/registrations/${reg.id}/cancel`)
            .catch(e => {
                console.log(e?.response?.data);
                setItems(oldItems);
            })
    }


    return <Layout tab='orphans' menu='crm' title='Inscriptions DPC non affectées'>

        <Grid 
            id='orphansGrid'
            columns={columns}
            rows={items}
            toolbar
        />

    </Layout>

}


